module.exports = {
    ON_AIR_VH_GET: 'ON_AIR_VH_GET',
};
